import Vue from 'vue'

/**
 * @autor Andrés Aguilar <andresyoshimar@gmail.com>
 */

const sendSinisterPackage = (sinisters, dolar) => {
  let relatedAffected = []
  sinisters.forEach((element) => {
    relatedAffected.push(element.id)
  })
  const payload = {
    related_affected: relatedAffected,
    exchange_price: Number(dolar).toFixed(6),
  }

  return Vue.$http.post('extranet/package/', payload)
    .then(response => response.data)
    .catch((err) => { throw err })
}

export default sendSinisterPackage


// WEBPACK FOOTER //
// ./src/services/extranet/sendSinisterPackage.js